<div>
  <OnboardingIndex
    title="First Time Login"
    submitButtonText="Submit"
    :verification_running="action_running"
    @submit="first_time_login"
  >
    <template v-slot:form-content>
      <div class="row">
        <div class="col-md-6 mb-3">
          <label for="first-name" class="text-xs">First Name</label>
          <input
            id="first-name"
            v-model="user_first_name"
            class="form-control form-control-lg text-xxs bg-light py-2 pe-4 border-0"
            placeholder="Enter your first name"
            required
          />
        </div>
        <div class="col-md-6 mb-3">
          <label for="last-name" class="text-xs">Last Name</label>
          <input
            id="last-name"
            v-model="user_last_name"
            class="form-control form-control-lg text-xxs bg-light py-2 pe-4 border-0"
            placeholder="Enter your last name"
            required
          />
        </div>
      </div>

      <h6 class="text-dark text-xs">
        Create a password to secure your account.
      </h6>

      <div class="mb-3 position-relative">
        <label for="password" class="text-xs">New Password</label>
        <input
          id="password"
          :type="show_password ? 'text' : 'password'"
          v-model="new_password"
          class="form-control form-control-lg text-xxs bg-light py-2 pe-5 border-0"
          placeholder="Enter your password"
          required
        />
        <i
          :class="show_password ? 'bi bi-eye' : 'bi bi-eye-slash'"
          class="position-absolute end-0 top-50 translate-middle-y-eye me-3 text-secondary cursor-pointer z-2"
          @click="toggle_password_visibility"
        ></i>
      </div>

      <div class="mb-3 position-relative">
        <label for="confirm_password" class="text-xs">Confirm password</label>
        <input
          id="confirm_password"
          :type="show_confirm_password ? 'text' : 'password'"
          v-model="confirm_password"
          class="form-control form-control-lg text-xxs bg-light py-2 pe-5 border-0"
          placeholder="Confirm your password"
          required
        />
        <i
          :class="show_confirm_password ? 'bi bi-eye' : 'bi bi-eye-slash'"
          class="position-absolute end-0 top-50 translate-middle-y-eye me-3 text-secondary cursor-pointer z-2"
          @click="toggle_confirm_password_visibility"
        ></i>
      </div>

      <div class="mb-3">
        <label for="phone_number" class="text-xs">Phone Number</label>
        <input
          id="phone_number"
          v-model="phone_number"
          type="text"
          maxlength="10"
          class="form-control form-control-lg text-xxs bg-light py-2 border-0"
          placeholder="Enter phone number"
          @keypress="validate_numbers_only"
          oninput="this.value = this.value.replace(/\D/g, '')"
          required
        />
        <small
          v-if="phone_number && !validate_phone_number(phone_number)"
          class="text-danger p-2 text-xxs fw-bold d-block"
        >
          Please enter a valid 10-digit phone number
        </small>
      </div>
    </template>
  </OnboardingIndex>
</div>
